import type { CSSProperties } from 'react';

export type SeracGlyphVariant = 'strata' | 'prism' | 'notch';

interface SeracGlyphProps {
  size?: number;
  color?: string;
  variant?: SeracGlyphVariant;
  style?: CSSProperties;
}

/**
 * Serac glyph — three variants of the same brand mark.
 *
 *   strata: three stacked ice slabs, widening as they go down.
 *           reads as "layered / ice under pressure". (default)
 *   prism:  one faceted ice block seen at an angle.
 *           crisper, more premium.
 *   notch:  single solid block with a chevron fracture bitten
 *           out of the top. works as a 16px favicon.
 */
export default function SeracGlyph({
  size = 20,
  color = 'currentColor',
  variant = 'strata',
  style,
}: SeracGlyphProps) {
  const common = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', style };

  if (variant === 'prism') {
    return (
      <svg {...common}>
        <path d="M4 7 L12 3 L20 7 L12 11 Z" fill={color} fillOpacity="0.95" />
        <path d="M12 11 L20 7 L20 17 L12 21 Z" fill={color} fillOpacity="0.6" />
        <path d="M12 11 L4 7 L4 17 L12 21 Z" fill={color} fillOpacity="0.35" />
      </svg>
    );
  }

  if (variant === 'notch') {
    return (
      <svg {...common}>
        <path d="M3 6 L9 6 L12 9 L15 6 L21 6 L21 19 L3 19 Z" fill={color} />
      </svg>
    );
  }

  return (
    <svg {...common}>
      <path d="M8 5 L16 5 L17.5 8 L6.5 8 Z" fill={color} fillOpacity="0.95" />
      <path d="M6 9 L18 9 L19.5 13 L4.5 13 Z" fill={color} fillOpacity="0.7" />
      <path d="M4 14 L20 14 L22 19 L2 19 Z" fill={color} fillOpacity="0.45" />
    </svg>
  );
}
